var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Layout',[_c('div',{staticClass:"rwt-video-popup-area rn-section-gap"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12"},[_c('SectionTitle',{attrs:{"text-align":"center","subtitle":"视频介绍"}})],1)]),_c('Video',{attrs:{"video-data":_vm.videoData}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }